import moment from 'moment';
import { CarbonCopyResult } from '../carbon-copy';
import { Priority, TicketStatus, UserMode } from '../enums';
import { TicketLevel } from '../enums/ticket-level.enum';

export class TicketResult {
    public id: number = 0
    public customerEmployeeId: number = 0;
    public customerEmployeeName: string = '';
    public customerId: number = 0;
    public customerName: string = '';
    public projectId: number = 0;
    public projectName: string = '';
    public creationDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public creatorUserId: number = 0;
    public creatorUserFullName: string = '';
    public creatorUserMode: UserMode = UserMode.CustomerEmployee;
    public personalPictureFileName: string = '';
    public priority: Priority = Priority.VeryLow;
    public ticketStatus: TicketStatus = TicketStatus.Unassigned;
    public ticketLevel : TicketLevel = TicketLevel.Level0;
    public storyPoint : Number = 0;
    public ticketTypeId: number = 0;
    public ticketTypeName: string = '';
    public title: string = '';
    public assignedEmployeeId: number | null = null;
    public assignedEmployeeFullName: string = '';
    public assignedEmployeePersonalPictureFileName: string = '';
    public isDeleted: boolean = false;
    public status: boolean | null = false;
    public carbonCopies: Array<CarbonCopyResult> = [];
    public editDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public lastComment: UserMode = UserMode.CustomerEmployee;
    public commentCount: number = 0;
}
